import type { Locale } from '../../../../../../../../localization/i18n'

interface Props {
  dateStr: string
  locale: Locale
  timeZone: string
}

export default function formatDate({ dateStr, locale, timeZone }: Props) {
  return new Date(dateStr).toLocaleDateString(locale, {
    weekday: 'short',
    month: '2-digit',
    day: '2-digit',
    timeZone,
  })
}
